import { render } from "./CommunityView.vue?vue&type=template&id=22a6b672&scoped=true"
import script from "./CommunityView.vue?vue&type=script&lang=js"
export * from "./CommunityView.vue?vue&type=script&lang=js"

import "./CommunityView.vue?vue&type=style&index=0&id=22a6b672&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a6b672"]])

export default __exports__